import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';


import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


import { getUIText } from '../../utils/index';

import { saveProject } from '../../modules/project';

import { removeProject } from '../../modules/projects';

import { closeDialog, openDialog, CREATE_NEW_PROJECT_DIALOG } from '../../modules/dialogs';

import { projectDeleteFromServer } from '../../modules/user';

class ProjectSave extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  doNotSave() {
    const {
      project,
      dialogs,
      onProjectRemoveServer,
      onProjectRemove,
      selectProject
    } = this.props;

    const {
      data
    } = dialogs ? dialogs : {};

    if (data) {
      if (project.hasOwnProperty('uuid')) {
        selectProject({
          id: data,
          doNotSaveToProjects: true
        });
      } else {
        onProjectRemove(project.id);
        selectProject({
          id: data,
          doNotSaveToProjects: true
        });
      }
    } else {
      if (!project.hasOwnProperty('uuid')) {
        onProjectRemove(project.id);
      }
      this.props.closeSaveProjectDialog();
      this.props.openCreateNewProjectDialog();
    }
  }

  save() {
    const {
      dialogs,
      project,
      selectProject
    } = this.props;

    const {
      data
    } = dialogs ? dialogs : {};

    if (data) {
      this.props.saveProject({id: data});
      this.props.closeSaveProjectDialog();
    } else {
      if (project.hasOwnProperty('uuid')) {
        this.props.saveProject({id: project.id});
      } else {
        this.props.saveNewProject();
      }
      this.props.closeSaveProjectDialog();
      this.props.openCreateNewProjectDialog();
    }
  }

  render() {
    const {
      closeSaveProjectDialog,
      translations,
      app,
      open
    } = this.props;

    return (
      <Dialog className="project-dropdown-dialog" open={open} onClose={closeSaveProjectDialog}>
        <DialogTitle>{getUIText('DIALOG_PROJECT-SAVE-TITLE', app.language, translations)}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {getUIText('DIALOG_PROJECT-SAVE-CONTENT-TEXT', app.language, translations)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={closeSaveProjectDialog}>
            {getUIText('GENERAL-CANCEL', app.language, translations)}
          </Button>
          <Button color="primary" autoFocus onClick={this.doNotSave.bind(this)}>
            {getUIText('GENERAL-NO', app.language, translations)}
          </Button>
          <Button color="primary" autoFocus onClick={this.save.bind(this)}>
            {getUIText('GENERAL-SAVE', app.language, translations)}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ProjectSave.propTypes = {
  app: PropTypes.object,
  project: PropTypes.object,
  dialogs: PropTypes.object,
  translations: PropTypes.object,
  onProjectRemoveServer: PropTypes.any,
  onProjectRemove: PropTypes.any,
  selectProject: PropTypes.any,
  closeSaveProjectDialog: PropTypes.any,
  openCreateNewProjectDialog: PropTypes.any,
  saveProject: PropTypes.any,
  saveNewProject: PropTypes.any,
  open: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    app: state.app,
    project: state.project,
    dialogs: state.dialogs,
    translations: state.translations,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeSaveProjectDialog: () => dispatch(closeDialog()),
    openCreateNewProjectDialog: () => dispatch(openDialog({dialog: CREATE_NEW_PROJECT_DIALOG})),
    saveProject: (data) => dispatch(saveProject(data)),
    saveNewProject: (data) => dispatch(saveProject()),
    selectProject: (data) => {
      dispatch(selectProject(data));
      dispatch(closeDialog());
    },
    onProjectRemove: id => {
      dispatch(removeProject({ id: id }));
      dispatch(closeDialog());
    },
    onProjectRemoveServer: project => {
      dispatch(projectDeleteFromServer({
        project: project,
      }
      )
      );
      dispatch(closeDialog());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProjectSave);
